import React from 'react';
import { Box, Container, Grid, Typography, Paper } from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import GroupsIcon from '@mui/icons-material/Groups';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const InfoSection = () => {
  const infoItems = [
    {
      icon: <EmojiEventsIcon sx={{ fontSize: { xs: 60, md: 80 } }} />,
      title: 'The National Gauntlet Federation',
      description:
        'A new era of competitive grappling. High Energy. Fast Pace. Submission Focused. Team Driven.',
    },
    {
      icon: <GroupsIcon sx={{ fontSize: { xs: 60, md: 80 } }} />,
      title: 'What Makes NGF Different?',
      description:
        'Designed for grapplers and spectators. Family friendly, halftime games, mascots, food trucks, kid play areas and more!',
    },
    {
      icon: <CalendarMonthIcon sx={{ fontSize: { xs: 60, md: 80 } }} />,
      title: 'When?',
      description: 'Tournament starts Spring 2027',
    },
  ];

  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        backgroundColor: 'background.paper',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '6px',
          background: 'linear-gradient(90deg, #0D47A1 0%, #D32F2F 50%, #0D47A1 100%)',
        },
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {infoItems.map((item, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  height: '100%',
                  textAlign: 'center',
                  backgroundColor: 'white',
                  border: '2px solid',
                  borderColor: 'transparent',
                  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                  position: 'relative',
                  overflow: 'hidden',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '4px',
                    backgroundColor: index % 2 === 0 ? 'primary.main' : 'secondary.main',
                    transform: 'scaleX(0)',
                    transformOrigin: 'left',
                    transition: 'transform 0.4s ease',
                  },
                  '&:hover': {
                    borderColor: index % 2 === 0 ? 'primary.main' : 'secondary.main',
                    transform: 'translateY(-8px)',
                    boxShadow: `0 12px 32px ${
                      index % 2 === 0 ? 'rgba(13, 71, 161, 0.2)' : 'rgba(211, 47, 47, 0.2)'
                    }`,
                    '&::before': {
                      transform: 'scaleX(1)',
                    },
                  },
                }}
              >
                <Box
                  sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: { xs: 100, md: 120 },
                    height: { xs: 100, md: 120 },
                    borderRadius: '50%',
                    backgroundColor: index % 2 === 0 ? 'primary.main' : 'secondary.main',
                    color: 'white',
                    mb: 3,
                    transition: 'transform 0.3s ease',
                    '&:hover': {
                      transform: 'rotate(5deg) scale(1.1)',
                    },
                  }}
                >
                  {item.icon}
                </Box>

                <Typography
                  variant="h5"
                  sx={{
                    mb: 2,
                    color: index % 2 === 0 ? 'primary.main' : 'secondary.main',
                    fontWeight: 700,
                    fontSize: { xs: '1.3rem', md: '1.5rem' },
                  }}
                >
                  {item.title}
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    color: 'text.secondary',
                    lineHeight: 1.8,
                    fontSize: { xs: '0.95rem', md: '1rem' },
                  }}
                >
                  {item.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>

        {/* Decorative Elements */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 20,
            right: 20,
            width: 200,
            height: 200,
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(13, 71, 161, 0.05) 0%, transparent 70%)',
            pointerEvents: 'none',
            display: { xs: 'none', md: 'block' },
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: 40,
            left: -50,
            width: 250,
            height: 250,
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(211, 47, 47, 0.05) 0%, transparent 70%)',
            pointerEvents: 'none',
            display: { xs: 'none', md: 'block' },
          }}
        />
      </Container>
    </Box>
  );
};

export default InfoSection;